import {parseListingSearch,serializeListingSearch,searchFilterKeys,normalizeSearchBounds} from '../../../shared/listingSearch.js';

/** Saved criteria reopen on page one. Malformed known scalar filters remain visible for correction. */
export function savedSearchUrl(filters={}){
 if(!filters||typeof filters!=='object'||Array.isArray(filters))return '/search';
 const safe={};let malformed=false;for(const key of [...searchFilterKeys,'q','bbox']){
  if(key==='page')continue;const value=filters[key];
  if((typeof value==='string'&&value.trim())||typeof value==='boolean'||(typeof value==='number'&&Number.isFinite(value)))safe[key]=value;else if(value!==undefined&&value!==null&&key!=='mapBounds'){safe[key]='invalid';malformed=true;}
 }
 const bounds=normalizeSearchBounds(filters.mapBounds);if(bounds)safe.mapBounds=bounds;else if(filters.mapBounds&&Object.keys(filters.mapBounds).length)safe.bbox='invalid';
 if(malformed)safe.mode='invalid';
 const parsed=parseListingSearch(safe,{legacyNatural:true});let params;
 if(!Object.keys(parsed.errors).length)params=serializeListingSearch(parsed.state);
 else {params=new URLSearchParams(Object.entries(safe).filter(([key])=>key!=='mapBounds'));if(bounds)params.set('bbox',[bounds.minLng,bounds.minLat,bounds.maxLng,bounds.maxLat].join(','));if(params.has('search')){params.set('q',params.get('search'));params.delete('search');}if(params.has('q')&&!params.has('mode'))params.set('mode','keyword');}
 return params.size?`/search?${params}`:'/search';
}

/** Resolve only declared public detail routes and collection directories. */
export function favoriteTargetUrl(favorite) {
  const id = typeof favorite?.targetId === "string" ? favorite.targetId.trim() : "";
  if (!id) return null;
  if (favorite.targetType === "listing") return `/listings/${encodeURIComponent(id)}`;
  if (favorite.targetType === "project") return `/projects/${encodeURIComponent(id)}`;
  if (favorite.targetType === "service_provider") return "/services";
  if (favorite.targetType === "investment") return `/invest/${encodeURIComponent(id)}`;
  return null;
}

export function favoriteTitle(record, language = "en") {
  const values = [record?.label, record?.title, language === "ar" ? record?.titleAr : record?.titleEn, record?.titleEn, record?.titleAr, record?.name];
  for (const value of values) {
    if (typeof value === "string" && value.trim()) return value;
    if (value && typeof value === "object") {
      const localized = [value[language], value.en, value.ar].find((item) => typeof item === "string" && item.trim());
      if (localized) return localized;
    }
  }
  return "";
}

export function canHydrateFavorite(record, services) {
  return !favoriteTitle(record) && typeof record?.targetId === "string" && Boolean(record.targetId.trim())
    && ["listing", "project", "investment"].includes(record.targetType) && typeof services[record.targetType] === "function";
}

/** Read only the current collection, with bounded concurrency and incremental results. */
export async function hydrateFavoriteDetails(records, services, { signal, onResult = () => {} } = {}) {
  const queue = records.slice(0, 100).filter((record) => canHydrateFavorite(record, services));
  let next = 0;
  const worker = async () => {
    while (!signal?.aborted && next < queue.length) {
      const record = queue[next++];
      let detail;
      try {
        const data = await services[record.targetType](record.targetId, { signal });
        detail = data && typeof data === "object" && !Array.isArray(data) ? { status: "ready", data } : { status: "unavailable" };
      } catch (error) {
        detail = { status: [404, 410].includes(error?.status) ? "unavailable" : "error" };
      }
      if (!signal?.aborted) onResult(String(record._id || record.id || ""), detail);
    }
  };
  await Promise.all(Array.from({ length: Math.min(3, queue.length) }, worker));
}
